const CONFIG_PAYMENT = {
    TOTAL_PAYMENT: 3
};

export const imageChain = (chainId: string) => {
    switch (chainId) {
        case '1':
            return 'https://s3.ap-southeast-1.amazonaws.com/tvn.payme/images/coins/ETH.png';
        case '56':
            return 'https://s3.ap-southeast-1.amazonaws.com/tvn.payme/images/coins/BNB.png';
        case 'TRX':
            return 'https://s3.ap-southeast-1.amazonaws.com/tvn.payme/images/coins/TRX.png';
        default:
            return 'https://s3.ap-southeast-1.amazonaws.com/tvn.payme/images/coins/ETH.png';
    }
};

export const cutChainName = (chainName: string) => {
    const start = chainName.indexOf('(');
    const end = chainName.indexOf(')');
    return chainName.slice(start + 1, end);
};

export default CONFIG_PAYMENT;
